import {mergeViewStateForFulfillment} from "../../../Cob.helpers";
import Validator from "../../../../../classes/Validator";


export default function (state, prevState)
{
	if (import.meta.env.VITE_CHECK_VIEW_FULFILLMENT === "0")
	{
		return true;
	}

	state = mergeViewStateForFulfillment(state, prevState);
	const {customerState} = state;

	if (state.pageDisabled)
	{
		return true;
	}

	if (state.accountNaked)
	{
		if (customerState["uppdragsavtal_af_task_1"].length <= 0 ||
			customerState["uppdragsavtal_af_fee_1"].length <= 0 ||
			customerState["uppdragsavtal_af_fee_1"] === "-")
		{
			return false;
		}

		for (let i = 1; i <= 3; i++)
		{
			const taskEmpty = customerState["uppdragsavtal_af_task_" + i].length <= 0 || customerState["uppdragsavtal_af_task_" + i] === "-";
			const feeEmpty = customerState["uppdragsavtal_af_fee_" + i].length <= 0 || customerState["uppdragsavtal_af_fee_" + i] === "-";
			if ((!taskEmpty && feeEmpty) || (!feeEmpty && taskEmpty))
			{
				return false;
			}
		}
	}

	if (state.accountIsk)
	{
		if (customerState["uppdragsavtal_isk_task_1"].length <= 0 ||
			customerState["uppdragsavtal_isk_fee_1"].length <= 0 ||
			customerState["uppdragsavtal_isk_fee_1"] === "-")
		{
			return false;
		}

		for (let i = 1; i <= 3; i++)
		{
			const taskEmpty = customerState["uppdragsavtal_isk_task_" + i].length <= 0 || customerState["uppdragsavtal_isk_task_" + i] === "-";
			const feeEmpty = customerState["uppdragsavtal_isk_fee_" + i].length <= 0 || customerState["uppdragsavtal_isk_fee_" + i] === "-";
			if ((!taskEmpty && feeEmpty) || (!feeEmpty && taskEmpty))
			{
				return false;
			}
		}
	}

	if (state.accountKf)
	{
		if (customerState["uppdragsavtal_kf_task_1"].length <= 0 ||
			customerState["uppdragsavtal_kf_fee_1"].length <= 0 ||
			customerState["uppdragsavtal_kf_fee_1"] === "-")
		{
			return false;
		}

		for (let i = 1; i <= 3; i++)
		{
			const taskEmpty = customerState["uppdragsavtal_kf_task_" + i].length <= 0 || customerState["uppdragsavtal_kf_task_" + i] === "-";
			const feeEmpty = customerState["uppdragsavtal_kf_fee_" + i].length <= 0 || customerState["uppdragsavtal_kf_fee_" + i] === "-";
			if ((!taskEmpty && feeEmpty) || (!feeEmpty && taskEmpty))
			{
				return false;
			}
		}
	}

	if (state.accountTp)
	{
		if (customerState["uppdragsavtal_tp_task_1"].length <= 0 ||
			customerState["uppdragsavtal_tp_fee_1"].length <= 0 ||
			customerState["uppdragsavtal_tp_fee_1"] === "-")
		{
			return false;
		}

		for (let i = 1; i <= 3; i++)
		{
			const taskEmpty = customerState["uppdragsavtal_tp_task_" + i].length <= 0 || customerState["uppdragsavtal_tp_task_" + i] === "-";
			const feeEmpty = customerState["uppdragsavtal_tp_fee_" + i].length <= 0 || customerState["uppdragsavtal_tp_fee_" + i] === "-";
			if ((!taskEmpty && feeEmpty) || (!feeEmpty && taskEmpty))
			{
				return false;
			}
		}
	}

	if (customerState.uppdragsavtal_confirm_terms !== "Ja")
	{
		return false;
	}

	if (customerState.uppdragsavtal_confirm_forkop !== "Ja")
	{
		return false;
	}

	if (customerState.uppdragsavtal_confirm_pricelist !== "Ja")
	{
		return false;
	}

	return true;
}